<div class="chart-card">
    <h3 class="chart-title">{{ 'request_v2.analytics.category_chart_title' | translate }}</h3>
    <div class="chart-container">
        <canvas baseChart
            *ngIf="data.length > 0"
            type="doughnut"
            [data]="chartData"
            [options]="chartOptions">
        </canvas>
        <div *ngIf="data.length === 0" class="no-data">
            {{ 'request_v2.analytics.no_data' | translate }}
        </div>
    </div>
</div>
